import { Select, SelectInstance, SelectOption } from '@cimplico/components';
import { Ref, useState } from 'react';
import { WorkpaperRoleEnum } from '../../types/workpaper';

type RoleSelectProps = {
    defaultRole?: WorkpaperRoleEnum;
    title?: string;
    isOptional?: boolean;
    isMulti?: boolean;
    isDisabled?: boolean;
    placeholder?: string;
    form?: string;
    errorMessage?: string;
    onChange: (role?: WorkpaperRoleEnum) => void;
    innerRef?: Ref<SelectInstance>;
};

function RoleSelect({
    defaultRole,
    title,
    isMulti = false,
    isOptional = false,
    isDisabled = false,
    placeholder,
    form,
    errorMessage,
    onChange,
    innerRef,
}: RoleSelectProps): JSX.Element {
    const [selected, setSelected] = useState(defaultRole ? [defaultRole] : []);
    function handleRoleChange(options: SelectOption[]): void {
        if (options.length === 0) {
            setSelected([]);
            onChange(undefined);
        } else {
            setSelected(options.map((o) => o.value as WorkpaperRoleEnum));
            options.map((o) => onChange(o.value as WorkpaperRoleEnum));
        }
    }

    return (
        <Select
            placeholder={placeholder || 'Select a role...'}
            title={title}
            form={form}
            isOptional={isOptional}
            isMulti={isMulti}
            isDisabled={isDisabled}
            errorMessage={errorMessage}
            onChange={(options): void => {
                handleRoleChange(options);
            }}
            options={[
                {
                    value: WorkpaperRoleEnum.PREPARER,
                    label: 'Preparer',
                    isSelected: selected.includes(WorkpaperRoleEnum.PREPARER),
                },
                {
                    value: WorkpaperRoleEnum.REVIEWER,
                    label: 'Reviewer',
                    isSelected: selected.includes(WorkpaperRoleEnum.REVIEWER),
                },
                {
                    value: WorkpaperRoleEnum.APPROVER,
                    label: 'Approver',
                    isSelected: selected.includes(WorkpaperRoleEnum.APPROVER),
                },
            ]}
            ref={innerRef}
        />
    );
}
export default RoleSelect;
